import { VersaoProvider } from './../versao/versao';
import { AtendimentoModel } from './../../app/models/AtendimentoModel';
import { VeiculoCampModel } from './../../app/models/VeiculoModel';
import { ModeloModel } from './../../app/models/CardapioModel';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';
import { ConfigHelper } from '../../app/helpers/configHelper';
import { Storage } from '@ionic/storage';
import { MarcaModeloAgrupadoModel } from '../../app/models/MarcaModeloModel';

@Injectable()
export class CardapioOnlineProvider {

  tipoVeiculo: string;

  constructor(private httpSrv: HttpProvider, public storage: Storage) {
    
  }

  async getMarcaModelo(Projeto: number): Promise<Array<MarcaModeloAgrupadoModel>> {
    try {
      let ResultConn = await this.httpSrv.getApi('v1/marcamodelo', 1, 'Carregando Marcas e Modelos ...', null, 900000);
      if (ResultConn.success) {
        return <Array<MarcaModeloAgrupadoModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }

  async getPacotesTrocaOleo(_carroversao: any, atendimento: AtendimentoModel, loading = 1) {
    if(atendimento.idAtendimento){
      _carroversao.idAtendimento = atendimento.idAtendimento;
    }
    if(this.storage.get('tipoVeiculo')){
      await this.storage.get('tipoVeiculo').then((tipo) => {
        _carroversao.tipoVeiculo = tipo;
      });
    }

    try {
      let ResultConn = await this.httpSrv.postApi('v1/getCardapio',  _carroversao, loading, 1);
      
      if (ResultConn.success) {
        return <ModeloModel>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }

  async getOfertaInformacoes(codConcessionaria: number, _carroversao: any, loading = 1): Promise<ModeloModel> {
    let body = _carroversao;
    body.idLoja = codConcessionaria;
    if(this.storage.get('tipoVeiculo')){
      await this.storage.get('tipoVeiculo').then((tipo) => {
        this.tipoVeiculo = tipo;
      });
    }

    body.tipoVeiculo = this.tipoVeiculo;
    try {
      let ResultConn = await this.httpSrv.postApi('v1/getOferta', body, loading);
      
      if (ResultConn.success){
        
          return ResultConn.data;
        
      }
    } catch (error) 
    {
      console.log('problema ao autenticar provider configuracao - concessionaria', error);
    }
  }

  async getServicosPersonalizados(): Promise<Array<any>> {
    return await this.storage.get('serviçosPersonalizados');
  }

  async getServicosPersonalizadoByCodigo(extra: number): Promise<any> {
    let dados = this.getServicosPersonalizados();
        let result = (await dados).find(dado => dado.codigo == extra);
        return result;
  }

  async getPlacaCamp(cnpj: string, placa: string): Promise<VeiculoCampModel> {
    try {
      let ResultConn = await this.httpSrv.getDms(placa, 1000000, 'Buscando dados da placa...');
      if (ResultConn.success) {
        return <VeiculoCampModel>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as busca placa Camp online', error);
    }
  }
  async isCardapios(): Promise<any> {
    return await this.storage.get(ConfigHelper.storageKeys.cardapios);
  }
  async isMarcaModelo(): Promise<any> {
    return await this.storage.get(ConfigHelper.storageKeys.marcamodelo);
  }

}


// WEBPACK FOOTER //
// ./src/providers/cardapio-online/cardapio-online.ts